import styled, { css } from 'styled-components'
import { theme } from '~/styles'

interface StylesProps {
  width?: string
}

type ButtonColors = 'primary' | 'success' | 'error' | 'warning' | 'disabled'

interface Button {
  color?: ButtonColors
  variant?: 'outlined' | 'contained'
  isLoading?: boolean
  minWidth?: 'small' | 'medium' | 'large'
  styles: StylesProps
  disabled?: boolean
}

const colors: Record<ButtonColors, string> = {
  warning: theme.colors.colorFF8729,
  disabled: theme.colors.color378ff7,
  success: theme.colors.color4CAF50,
  error: theme.colors.colorFF2424,
  primary: theme.colors.color378ff7
}

export const ButtonWrapper = styled.button<Button>`
  ${({ color = 'primary', variant = 'contained', theme, disabled, isLoading }) => css`
    background-color: ${variant === 'outlined' ? 'transparent' : colors[color]};
    border: 1px solid ${disabled ? theme.colors.color6b7786 : colors[color]};
    color: ${variant === 'outlined' ? colors[color] : theme.zds.colors.neutral1000};

    canvas {
      background: ${variant === 'contained' ? theme.zds.colors.neutral1000 : colors[color]};
    }

    ${disabled &&
    css`
      opacity: 40%;
      background-color: ${variant === 'outlined' ? 'transparent' : theme.colors.color6b7786};
      color: ${variant === 'outlined' ? theme.colors.color6b7786 : theme.zds.colors.neutral1000};
      border: 1px solid ${theme.colors.color6b7786};
    `};

    :hover {
      background-color: ${color === 'primary' ? theme.colors.color257ce5 : colors[color]};
      color: ${theme.zds.colors.neutral1000};

      ${disabled &&
      css`
        background-color: ${variant === 'outlined' ? 'transparent' : theme.colors.color6b7786};
        color: ${variant === 'outlined' ? theme.colors.color6b7786 : theme.zds.colors.neutral1000};
      `};

      ${isLoading &&
      css`
        background-color: ${variant === 'outlined' ? 'transparent' : colors[color]};
      `}
    }

    canvas {
      background: ${variant === 'contained' ? colors[color] : theme.zds.colors.neutral1000};
    }

    font-family: 'Inter';
    font-weight: 600;
    line-height: 0%;
    height: 40px;
    font-size: 14px;
    padding: 12px ${theme.zds.spacing.insetEqual600};
    border-radius: ${theme.zds.border.radius100};
    cursor: ${color === 'disabled' ? 'not-allowed' : 'pointer'};
    outline: none;
    transition: all 0.2s;
    text-align: center;
    min-width: ${props =>
      props.minWidth === 'small'
        ? '100px'
        : props.minWidth === 'medium'
          ? '180px'
          : props.minWidth === 'large'
            ? '200px'
            : 'auto'};
    width: ${(props: Button) => props.styles.width};
  `};
`

export const ChildrenWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`
